// ponytail: no LEVELS map — only MIN_LEVEL matters. Upgrade path: add runtime level override via localStorage.
const MIN_LEVEL: number = import.meta.env.PROD ? 2 : 0;

export function createLogger(label: string) {
  const prefix = `[${label}]`;
  return {
    debug: (...args: unknown[]) => { if (MIN_LEVEL <= 0) console.debug(prefix, ...args); },
    info:  (...args: unknown[]) => { if (MIN_LEVEL <= 1) console.info(prefix, ...args); },
    warn:  (...args: unknown[]) => { if (MIN_LEVEL <= 2) console.warn(prefix, ...args); },
    error: (...args: unknown[]) => { if (MIN_LEVEL <= 3) console.error(prefix, ...args); },
  };
}
